<template>
    <Transition name="menu-fade">
      <div v-if="open" class="request-overlay" @click.self="close">
        <Transition name="menu-pop">
          <div v-if="open" class="request-panel" role="dialog" aria-modal="true" aria-label="You live request">
            <header class="request-header">
              <h2 class="request-title">Notifications</h2>
              <button type="button" class="request-close" aria-label="Close" @click="close">
                <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              </button>
            </header>

            <ul class="request-list">
              <li v-if="(notifications.length +requests.length) === 0" class="request-empty">No new notification.</li>
              <li v-for="request in requests" :key="request._id" class="request-list__item">
                <ShortLiveCard :request="request" @click="handleSelect" />
              </li>
              <li v-for="notif in notifications" :key="notif._id" class="request-list__item">
                <ShortLiveCard :request="notif" type="notification" @click="openNotification" />
              </li>
            </ul>
          </div>
        </Transition>
      </div>
    </Transition>
</template>

<script setup>
/* eslint-disable no-undef */
import ShortLiveCard from './ShortLiveCard.vue'
import { ref, onMounted, computed, inject, watch } from "vue";
import { useStore } from 'vuex'
import { App } from '@capacitor/app' // for battery consomption improvment
import { useRouter } from 'vue-router'

const router = useRouter()

const store = useStore()

const axios = inject('axios')

const open = ref(false)
const showing = ref(false)
const requests = ref([])
const notifications = ref([])
const newNotifications = computed(() => notifications.value.filter((nt) => !nt.seenAt))

defineExpose({ show, requests, newNotifications, open, close })
const emit = defineEmits(['goToPeople'])
async function show () {
  open.value = true

  // set notifications as seen
  // Pause execution for 10 seconds (10,000 ms)
  if(showing.value) return
  showing.value = true
  await new Promise(resolve => setTimeout(resolve, 20000));
  await axios.post('/notification.php',{type:"seeAllByTypes",types:['pub', 'conf', 'status','follow']})
  showing.value = false
}
function close() {
  open.value = false
}

function handleSelect(request) {
  store.commit('setCurrentConference', request)
  close()
}

function openNotification(notif) {
 console.log(notif)
 if(notif.type === 'pub') router.push('/publication/'+notif.targetId)
 if(notif.type === 'follow') router.push('/profile/'+notif.targetId)
 if(notif.type === 'status') emit('goToPeople')
 close()
}

async function isAppInBackground() {
  // Check WebView visibility
  const isDocumentHidden = document.hidden

  // Check native Capacitor app state
  const { isActive } = await App.getState()

  // Consider the app in the background if either check indicates it
  return isDocumentHidden || !isActive
}

async function myConferences () {
  try {
    const inBackground = await isAppInBackground()
    if(inBackground) return 
    const { data } = await axios.post('/conference.php', { type: 'myConferences' })
    const { data: notifs} = await axios.post('/notification.php', { type: 'myNotification' })
    //console.log('notifications', notifs)
    notifications.value = notifs || []
    notifications.value = notifications.value.filter(not => not.type != 'conf' && not.type != 'message' )
    
    if(!data || data.length<0) return
    // get users publishers metadatas________________________________________________________________
    const usersToGet = new Set()
    data.forEach(conf => {
      if(!store.state.users[conf.userId]) usersToGet.add(conf.userId)
      conf.actors.forEach(act => {
        if(!store.state.users[act.userId]) usersToGet.add(act.userId)
      })
    })

    if(usersToGet.size > 0) {
      const res2 = await axios.post('user.php',{type:"getUsersMetaData",users:[...usersToGet]})
      const users = res2.data || []
      users.forEach(us => {
        store.commit('setAnUser',us)
      })
    }

    requests.value = data || []
  } catch (err) {
    console.error('Getting my conferences failed:', err)
  }
  finally { 
    setTimeout(myConferences,30000)
  }
}

watch(requests, (newVal, oldval) => {
  // if there is a new conference and that the last conference is not initiated by the current user
  if(newVal.length > oldval.length && newVal[newVal.length-1].userId !== store.state.user.uid ) show()
})

onMounted(async () => {
  //myConferences()
  myConferences()
})
</script>

<style scoped>
.request-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background: rgba(6, 9, 18, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
}

.request-panel {
  --bg-card: #10162a;
  --border: rgba(148, 163, 184, 0.1);
  --text-primary: #e7ebf5;
  --text-muted: #4b5670;

  width: 320px;
  min-height: 320px;
  max-width: 100%;
  max-height: 75%;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Inter', 'Sora', system-ui, -apple-system, sans-serif;
}

.request-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.request-title {
  margin: 0;
  font-size: 15.5px;
  font-weight: 700;
  font-family: 'Sora', 'Inter', sans-serif;
  color: var(--text-primary);
}

.request-close {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: rgba(148, 163, 184, 0.06);
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.request-close svg {
  width: 13px;
  height: 13px;
}

.request-list {
  list-style: none;
  margin: 0;
  padding: 8px;
  overflow-y: auto;
  flex: 1;
}

.request-empty {
  padding: 30px 12px;
  text-align: center;
  color: var(--text-muted);
  font-size: 13px;
}

/* ---- Transitions ---- */
.menu-fade-enter-active,
.menu-fade-leave-active {
  transition: opacity 0.2s ease;
}
.menu-fade-enter-from,
.menu-fade-leave-to {
  opacity: 0;
}

.menu-pop-enter-active {
  transition: opacity 0.2s ease, transform 0.22s cubic-bezier(0.34, 1.28, 0.64, 1);
}
.menu-pop-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.menu-pop-enter-from,
.menu-pop-leave-to {
  opacity: 0;
  transform: scale(0.94);
}

@media (max-width: 340px) {
  .request-panel { width: 280px; height: 280px; }
  .request-title { font-size: 14px; }
}
</style>